import { useEffect } from "react";

import { useMutation } from "@apollo/client/react";

import { DraftingStartDocument } from "@app_schema";

import { track } from "@application/utilities/track";

// Starts a case that has never had a draft from a copy of his template, once
// the tab opens on it. The server makes one copy however often it's asked.
export const useDraftingStart = (projectId: string, startable: boolean) => {
  const [start, { error }] = useMutation(DraftingStartDocument, {
    variables: { id: projectId },
    refetchQueries: ["DashboardProjectsDetails"],
  });

  useEffect(() => {
    if (!startable) return;
    void start()
      .then(() => track("drafting_started", { project_id: projectId }))
      .catch(() => undefined);
  }, [startable, start, projectId]);

  return error?.message;
};
